import { actions } from "utils/helpers";
import { toast } from "react-hot-toast";
import { UNAUTHORIZED } from "constants";
import Table from "components/Table/Table";
import { Globals } from "utils/styleconfig";
import { MdOutlineSort } from "react-icons/md";
import Button from "components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { selectAuthUser } from "features/auth/authSlice";
import Pagination from "components/Pagination/Pagination";
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { Fragment, useCallback, useEffect, useState } from "react";
import TableSkeleton from "components/Table/TableSkeleton/TableSkeleton";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import {
  useGetDIDsQuery,
  useDeleteDIDMutation,
} from "features/did/didApiSlice";

import cardStyles from "styles/modules/Card.module.scss";
import utilityStyles from "styles/modules/Utility.module.scss";

const DIDs = ({ label }) => {
  const navigate = useNavigate();
  
  const [searchParams] = useSearchParams();
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const {
    currentData,
    isFetching: isLoading,
    isError,
    error
  } = useGetDIDsQuery(searchParams.toString());

  const [toggleSort, setToggleSort] = useState(false);

  const authUser = useSelector(selectAuthUser);

  const dispatch = useDispatch();

  const [deleteDID] = useDeleteDIDMutation();

  useEffect(() => {
    dispatch(setNavbarTitle("DIDs"));
  }, [dispatch]);

useEffect(() => {
  if (isError && !errorDisplayed) {
    toast.error(error?.message || "Could not load dids, try refreshing the page");
    setErrorDisplayed(true);
  }
}, [isError, error, errorDisplayed]);


  const onItemClickHandler = (id) => {
    navigate(`/dids/${id}`);
  };

  // const onEditBtnHandler = useCallback(
  //   (id, callFn = false) => {
  //     if (authUser.actions[label].includes(actions.view)) {
  //       if (callFn) {
  //         navigate(`/dids/${id}`);
  //       }

  //       return "";
  //     }

  //     return UNAUTHORIZED;
  //   },
  //   [authUser.actions, label, navigate]
  // );

  const onDeleteBtnHandler = useCallback(
    async (id, callFn = false) => {
      if (authUser.actions[label].includes(actions.delete)) {
        if (callFn) {
          await deleteDID(id).unwrap();
        }

        return "";
      }

      return UNAUTHORIZED;
    },
    [authUser.actions, deleteDID, label]
  );

  const onSortList = (sortField) => {
    let currentParams = {};

    for (const [key, value] of searchParams.entries()) {
      currentParams[key] = value;
    }

    navigate({
      search: createSearchParams({
        ...currentParams,
        sort_by: sortField,
      }).toString(),
    });
  };

  return (
    <div>
      <div className={cardStyles.menu}>
        <h3>Showing data for dids</h3>
        <div className={cardStyles.menuOptions}>
          <Button
            onClick={() => setToggleSort((prev) => !prev)}
            className={utilityStyles.outline__button}
          >
            <MdOutlineSort color={Globals.colorDarkBlue} size={17} />
            <span>Sort by</span>
            {toggleSort && (
              <div className={utilityStyles.select__dropdown}>
                <span onClick={() => onSortList("number")}>Number</span>
                <span onClick={() => onSortList("enabled")}>Enabled</span>
              </div>
            )}
          </Button>
        </div>
      </div>
      {isLoading ? (
        <TableSkeleton />
      ) : (
        <Fragment>
          <Table
            data={currentData}
            onItemClickHandler={onItemClickHandler}
            onDelete={onDeleteBtnHandler}
          />
          <Pagination totalCount={currentData?.size} />
        </Fragment>
      )}
    </div>
  );
};

export default DIDs;
